import config from '@/config';
import NamespacedStorage from './namespaced-storage';

export default new NamespacedStorage(config.VUE_APP_STORAGE_PREFIX);
